import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { GeneralService } from "src/app/Service/general.service";
import Swal from "sweetalert2";

@Component({
  selector: 'app-add-auction-alert',
  templateUrl: './add-auction-alert.component.html',
  styleUrls: ['./add-auction-alert.component.scss']
})
export class AddAuctionAlertComponent implements OnInit {

  breadCrumbItems: Array<{}>;
  Auction: FormGroup;
  submitted: boolean = false;
  isLoading: boolean;
  users = [];
  subtype = [];
  district = [];
  taluka = [];
  village = [];
  Type: any;
  UserID: any;
  id: any;
  myValue: any;
  isShowDistrict: boolean = true;
  isShowTaluka: boolean = false;
  isShowVillage: boolean = false;
  newdate: string;
  constructor(  private fb: FormBuilder,
    private gs: GeneralService,
    private router: Router,
    private route: ActivatedRoute) {
      this.Type = this.route.snapshot.params.type;

      if (this.router.getCurrentNavigation()) {
        if (this.router.getCurrentNavigation().extras.state) {
          const state = this.router.getCurrentNavigation().extras.state;
  
          this.UserID = state["UserId"];
          // console.log("line=91", this.UserID);
          localStorage.setItem("UserID", state.UserId);
        } else {
          if (localStorage.getItem("UserID")) {
            this.UserID = localStorage.getItem("UserID");
          }
        }
      }
     }

  ngOnInit() {
    this.newdate = new Date().toISOString().substr(0, 10);
    this.breadCrumbItems = [
      { label: "Auction alert List", path: "/users/auctionAlert" },
      { label: "Add Auction Alert", path: "/", active: true },
    ];
    this.Auction = this.fb.group({
      UserID: new FormControl(this.UserID),
      Service_Sub_Type_ID: new FormControl(null, [Validators.required]),
      DistrictID: new FormControl(null, Validators.required),
      TalukaID: new FormControl(null),
      VillageID: new FormControl(null),
      startDate: new FormControl(null, [Validators.required,Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      endDate: new FormControl(null, [Validators.required,Validators.pattern('\\d{4}-\\d{2}-\\d{2}')]),
      // uname: new FormControl(null, [Validators.required]),
      aucfor: new FormControl(null, Validators.required),
      dist: new FormControl(null, Validators.required),
      tal: new FormControl(null),
      vill: new FormControl(null),
    },
    { validators: this.startDateBeforeEndDateValidator });

    
    this.gs.getSubType().subscribe(
      (Response: any) => {
        this.subtype = Response.data;
        // console.log("line==77", this.subtype);
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
    this.gs.getDistrict().subscribe(
      (Response: any) => {
        this.district = Response.data;
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || "").trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  startDateBeforeEndDateValidator(control: AbstractControl): ValidationErrors | null {
    const startDate = control.get('startDate').value;
    const endDate = control.get('endDate').value;

    if (startDate && endDate && startDate >= endDate) {
      return { startDateAfterEndDate: true };
    }
    return null;
  }
  
  onSubtype(e) {

    this.Auction.controls['Service_Sub_Type_ID'].setValue(
      e.Service_Sub_Type_ID);

    if(e.Service_Sub_Type_ID == 21){
      this.isShowDistrict = true;
      this.isShowTaluka = false;
      this.isShowVillage = false;
     
    }
   else if(e.Service_Sub_Type_ID == 22){
    this.isShowDistrict = true;
    this.isShowTaluka = true;
    this.isShowVillage = false;
  
    }
   else if(e.Service_Sub_Type_ID == 23){
    this.isShowDistrict = true;
    this.isShowTaluka = true;
    this.isShowVillage = true;
 
    }
    // else{
  
    // }
  }
  onDistrict(e) {
    this.Auction.controls["tal"].setValue(null);
    this.Auction.controls["vill"].setValue(null);
    this.Auction.controls["DistrictID"].setValue(e.ID);
    this.gs.getTaluka(this.Auction.controls.DistrictID.value).subscribe(
      (Response) => {
        this.taluka = Response.data;
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  onTaluka(e) {
    this.Auction.controls["TalukaID"].setValue(e.TalukaID);
    this.Auction.controls["vill"].setValue(null);
    this.gs.getVillage(this.Auction.controls.TalukaID.value).subscribe(
      (Response: any) => {
        this.village = Response.data;
      },
      (error) => {
        //Error callback
        this.isLoading = false;
        Swal.fire({
          title: error.status,
          text: "Internal Server Error",
          type: "error",
        });
        //throw error;   //You can also throw the error to a global error handler
      }
    );
  }
  onVillage(e) {
    this.Auction.controls["VillageID"].setValue(e.VillageID);
  }
  datechange() {
    this.Auction.controls["endDate"].setValue(null);
    var date = new Date(this.Auction.controls.startDate.value);
    this.Auction.controls.endDate.setValue(this.add_years(date, 1).toISOString().substr(0, 10));
  }
  add_years(dt,n)
  {
    return new Date(dt.setFullYear(dt.getFullYear() + n));      
  }
  get f() {
    return this.Auction.controls;
  }
  
  onSubmit() {
    console.log(this.Auction.controls);
    this.isLoading = true;
    this.submitted = true;
    this.Auction["UserID"] = this.UserID;

    if (this.Auction.valid) {
      delete this.Auction.value.aucfor;
      delete this.Auction.value.dist;
      delete this.Auction.value.tal;

      delete this.Auction.value.vill;

      this.gs
        .AddAuction(this.Auction.value.UserID, this.Auction.value)
        .subscribe(
          (data) => {
            this.isLoading = false;

            if (data.status === 200) {
              this.submitted = false;
              Swal.fire({
                title: "Auction Uploaded",
                text: data.message,
                type: "success",
              }).then(() => {
                this.submitted = false;
                // this.reFresh.emit();
                this.router.navigate(["/users/auctionAlert"]);
              });
            } else {
              Swal.fire({
                text: data.Message,
                type: "info",
              });
              this.router.navigate(["/users/auctionAlert"]);
            }
          },
          (error) => {
            //Error callback
            this.isLoading = false;
            Swal.fire({
              title: error.status,
              text: "Internal Server Error",
              type: "error",
            });
            //throw error;   //You can also throw the error to a global error handler
          }
        );
    }
    this.isLoading = false;
  }

}
